"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Bath = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Bath = function Bath(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.113c.12 0 .24-.048.331-.143l.25-.259a.499.499 0 000-.687.457.457 0 00-.663 0l-.25.259c-.296.307-.082.83.332.83zm2 .259c.12 0 .24-.048.331-.143l.25-.259a.499.499 0 000-.687.457.457 0 00-.663 0l-.25.26c-.296.306-.082.829.332.829zm-2 1.815c.12 0 .24-.048.331-.143l.25-.26a.499.499 0 000-.686.457.457 0 00-.663 0l-.25.259c-.296.307-.082.83.332.83z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.469 9.26H15.53a.478.478 0 00.47-.486.478.478 0 00-.469-.486h-.563V2.21C14.969.99 14.017 0 12.838 0c-.493 0-.973.179-1.353.502l-.294.25a1.676 1.676 0 00-2.088.276l-.707.733a.499.499 0 000 .687l1.768 1.833c.183.19.48.19.663 0 .75-.778.704-.733.707-.733a1.835 1.835 0 00.306-2.09l.24-.205c.211-.18.479-.28.753-.28.64-.007 1.199.533 1.199 1.238v6.077H.469A.478.478 0 000 8.774c0 .268.21.486.469.486zm.811.972l.199 1.14c.297 1.694 1.51 3.01 3.052 3.44v.702c0 .268.21.486.469.486a.478.478 0 00.469-.486v-.554c.146.005 4.933.005 5.062 0v.554c0 .268.21.486.469.486a.478.478 0 00.469-.486v-.701c1.542-.43 2.755-1.747 3.052-3.442l.2-1.139H1.279z",
    fill: "currentColor"
  }));
};

exports.Bath = Bath;
var _default = Bath;
exports.default = _default;